import { Image, inputRegex } from '@tiptap/extension-image'
import { nodeInputRule } from '@tiptap/core';

export const customImage = Image.extend({

  addAttributes () {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      'uploading': {
        default: null,

        // Take the attribute values
        renderHTML: attributes => {
          // … and return an object with HTML attributes.
          return {
            'data-uploading': attributes.uploading,
          }
        },
      },
    }
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: match => {
          const [,, alt, src, title, uploading] = match

          return { src, alt, title, uploading }
        },
      }),
    ]
  },

  addNodeView() {
    return ({ node, HTMLAttributes, getPos, editor }) => {
      
      console.log('the node', node);
      console.log('HTMLAttributes', HTMLAttributes);

      const imgItem = document.createElement('img');

      Object.entries(this.options.HTMLAttributes).forEach(([key, value]) => {
        imgItem.setAttribute(key, value)
      })

      return {
        dom: imgItem,
        contentDom: content,
      }
    }
  },
})